// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__nWOdp","image":"Logo_image__G_0Sc","h1":"Logo_h1__65bsw","span":"Logo_span__3P-G9"};